import ExpandMoreIcon from '@mui/icons-material/ExpandMore';
import SubdirectoryArrowRightIcon from '@mui/icons-material/SubdirectoryArrowRight';
import { Accordion,AccordionDetails,AccordionSummary,Button,Divider,Stack,Typography } from '@mui/material';
import React from 'react';
import { duplicatasType } from '../../types/notifications/types';
import { trackEventMatomo } from '../../helpers/matomo';

export default function ChamadosDuplicados({ duplicatas }: { duplicatas: duplicatasType[] }) {
  const formataStatus = (value: string) => {
    switch (value) {
      case 'emandamento':
        return 'Em andamento';
      case 'pendente':
        return 'Pendente';
      case 'cancelado':
        return 'Cancelado';
      case 'concluido':
        return 'Concluido';
      case 'recusado':
        return 'Recusado';
      case 'fechadoDuplicidade':
        return 'Fechado por duplicidade';
    };
  };
  return (
    <Accordion
      style={{ width: '100%' }}
      onChange={(_event, expanded) => trackEventMatomo('chamado', 'click', 'acordeon', expanded ? 'expande duplicatas' : 'recolhe duplicatas')}
    >
      <AccordionSummary
        expandIcon={<ExpandMoreIcon />}
        aria-controls="panel1-content"
        id="panel1-header"
      >
        <Typography textAlign='center' color='textDisabled' fontWeight={700} variant='subtitle1'>Duplicatas</Typography>
      </AccordionSummary>
      <AccordionDetails>
        <Stack
          width='100%'
          direction='column'
          alignItems='stretch'
          justifyContent='flex-start'
          spacing={1.5}
        >
          {duplicatas?.map((item, index) => (
            <React.Fragment key={index}>
              <Stack
                width='100%'
                direction='row'
                alignItems='center'
                justifyContent='space-between'
              >
                <Stack>
                  <Typography component='p' color='textDisabled' fontWeight={600} fontSize={13}>Nome do chamado: <Typography component='span' fontSize={13}>{item.nome}</Typography></Typography>
                  <Typography component='p' color='textDisabled' fontWeight={600} fontSize={13}>Data de abertura: <Typography component='span' fontSize={13}>{item.inicio}</Typography></Typography>
                  <Typography component='p' color='textDisabled' fontWeight={600} fontSize={13}>Emitido por: <Typography component='span' fontSize={13}>{item.usuarioNome}</Typography></Typography>
                  <Typography component='p' color='textDisabled' fontWeight={600} fontSize={13}>Status: <Typography component='span' fontSize={13}>{formataStatus(item.status)}</Typography></Typography>
                </Stack>
                <Button
                  onClick={() => {
                    trackEventMatomo('chamado', 'click', 'botão', 'abre chamado duplicado');
                    window.open(process.env.REACT_APP_AXYMA_FRONT_URL + 'detalheChamado/' + item.id);
                  }}
                  variant='contained'
                  color='secondary'
                  endIcon={<SubdirectoryArrowRightIcon />}>
                  Ver chamado
                </Button>
              </Stack>
              <Divider variant="middle" />
            </React.Fragment>
          ))}
        </Stack>
      </AccordionDetails>
    </Accordion>
  );
};
